import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/locations'

export default {
  list(client = '', project = '', page, per_page, search) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, {
      client_id: client,
      project_id: project,
      page,
      per_page,
      search,
    })
  },
  edit(id, location) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, location)
  },
  create(location) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, location)
  },
  createAndReload(location) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, location)
  },
  getProject(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  delete(location) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${location}`)
  },
  getLocation(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },

}
